import { uploadCsvApi } from "./consts";
import { tokenHeader, getUserToken } from "./user-service";

const apiEndPoint = uploadCsvApi;

export const uploadCsvToProspect = (selectedFile) => {
  const formData = new FormData();
  formData.append("file", selectedFile);

  try {
    return fetch(apiEndPoint, {
      headers: {
        [tokenHeader]: getUserToken(),
      },
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then(
        (result) => {
          return result;
        },
        (error) => {
          return error;
        }
      );
  } catch (err) {
    console.log("Err :: uploadCsvToProspect ::>", err);
  }
};
